// @flow
import * as React from 'react';
import { IconMenuContainer, Icon, Icons, Item } from './styles';
import type { AnyIcon } from '~/core/constants/icons';
import { FormattedMessage } from 'react-intl';

type MenuItem = {
    icons: Array<AnyIcon>,
    label: $npm$ReactIntl$MessageDescriptor,
    key: string
};

type Props = {
    handleChange: (key: string) => void,
    disabled?: boolean,
    items: Array<MenuItem>,
    selectedKey: string
};

export default class IconMenu extends React.Component<Props, *> {
    handleClick = (key: string) => {
        this.props.handleChange(key);
    };

    renderMenuItem = (menuItem: MenuItem, disabled?: boolean) => {
        const isSelected = this.props.selectedKey === menuItem.key;
        return (
            <Item
                disabled={disabled}
                isSelected={isSelected}
                key={menuItem.key}
                onClick={() => !disabled && this.handleClick(menuItem.key)}
            >
                <Icons>
                    {menuItem.icons.map(icon => (
                        <Icon disabled={disabled} isSelected={isSelected} key={icon} type={icon} />
                    ))}
                </Icons>
                <FormattedMessage {...menuItem.label} />
            </Item>
        );
    };

    render() {
        const { items, disabled } = this.props;
        return <IconMenuContainer>{items.map(menuItem => this.renderMenuItem(menuItem, disabled))}</IconMenuContainer>;
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/icon-menu/index.js